import gql from "graphql-tag";

/**
 * VEHICLE-HISTORY (NUB-358): identity, the specs the Specs tab shows, stored Carfax records, and every field the
 * edit form sends back (the upsert replaces what it is not given).
 *
 * `skipUpdate` defaults to true here because the backend defaults it to false, which calls
 * Carfax and writes the response back on every read. Only the deliberate refresh passes false.
 */
export const GET_VEHICLE_FOR_HISTORY = gql`
  query getVehicleForHistory($id: ID!, $skipUpdate: Boolean = true) {
    getVehicle(id: $id, skipUpdate: $skipUpdate) {
      id
      contactId
      year
      make
      model
      subModel
      vin
      licensePlate
      licensePlateState
      odometer
      CCA
      name
      notes
      inactive
      vehicleTechnicalInfo {
        wheelTorque
        frontRotorsDiscardThicknessInches
        rearRotorsDiscardThicknessInches
        hasDrumBrakes
        parkingBrake
        oilCapacityQuarts
      }
      externalServiceHistory {
        source
        displayDate
        text
        displayText
        type
        odometer
        updatedAt
      }
    }
  }
`;
